import { Settings } from "@mui/icons-material";
import { IFeatures } from "@/utils/interfaces";
import { useSessionContext } from "@/contexts/SessionContext";

import { useOrganizationContext } from "@/contexts/OrganizationContext";
import QuestionnaireManage from "src-next/applications/mvp/pages/QuestionnaireManage";
import { currentFeatures } from "@/configs/Settings";

/**
 * Configura a página de gerenciar Questionnaires do form builder.
 */
export function useManageQuestionnaire() {
  const { access } = useSessionContext();
  const { organization } = useOrganizationContext();

  const configs: IFeatures = {
    active: access?.type === "professional",
    path: "/questionnaireManagement",
    icon: Settings,
    text: "Gerenciar questionários",

    subitem: true,
    parent: "Protocolos clínicos",

    sideMenu: true,
    sideMenuIndex: 0,

    component: () => (
      <QuestionnaireManage
        organizationId={organization?.id?.split("-")[1] || ""}
      />
    ),
  };

  return configs;
}
